<template>
  <Markdown
    as="div"
    :text="block.item.synopsis"
  />
</template>

<script setup lang="ts">
import type { TextBlock } from '~/types/blocks'

defineProps<{
  block: TextBlock
}>()
</script>
